import { ViewModelInfoRepresentanteLegal } from "./ViewModelInfoRepresentanteLegal.model";
import { ViewModelResponsavelFinanceiro } from "./ViewModelResponsavelFinanceiro.model";

export class WebPlanoAdesaoResponse {
    idConfigAdesao: number;
    nrCpf: string;
    nmPessoa: string;
    dtNascimento: string;
    icSexo: string;
    nmEmail: string;
    nrTelefone: string;
    icInvalidez: string;
    icPensaoMorte: string;
    nmFormaPagamento: string;
    nrDiaPagamento: number;
    nmRenda: string;
    idPlano: number;
    dtCadastro: string;
    nmBemVindo: string;
    icPrimeiroAcesso: string;
    idProcesso: number;
    idStatus: number;
    nrIdadeAposentadoria: number;
    nomeRepresentanteLegal: string;
    vlContribuicao: number;
    vlContribuicaoAdicional: number;
    opcaoRenda: string;
    nrPrazoRenda: number;
    icTentativaAdesao: string = "N";
    nmPlano: string;
    nrBanco: string;
    nrConta: string;
    nmAgencia: string;
    nrCpfvinculado: string;
    nmParentesco: string;
    responsavelFinanceiro: ViewModelResponsavelFinanceiro;
    representanteLegal: ViewModelInfoRepresentanteLegal;

}